import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Link
} from '@mui/material';
import { useSignupExisting } from 'api/services/RegistrationService';
import {
  SupplierPortalUserStatus,
  UserStateContextType,
  WHITELABEL_EVENT_KEY,
  COVALO_COMPANIES
} from 'components/constants/Constants';

import { useUserState } from 'context/User';
import { useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { Link as RouterLink } from 'react-router-dom';
import LoadingButton from '@mui/lab/LoadingButton';
import { useUserBelongsToCompanies } from 'hooks/useUserBelongsToCompanies';

export const EventSignupDialog: React.FC = () => {
  const [checked, setChecked] = useState(false);

  const userState = useUserState();
  const auth = useAuth();

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const [signupResult, signup] = useSignupExisting(WHITELABEL_EVENT_KEY!);

  const { belongsToCompany, loading } =
    useUserBelongsToCompanies(COVALO_COMPANIES);

  if (
    loading ||
    belongsToCompany ||
    // Event data not loaded yet
    userState.type === UserStateContextType.LOADING ||
    userState.type === UserStateContextType.NOT_AUTHENTICATED ||
    // User has not signed up to the event yet
    userState.user.supplierPortalUserStatus !==
      SupplierPortalUserStatus.NOT_SIGNED_UP ||
    // User just signed up
    signupResult.response?.status === 204
  ) {
    return null;
  }

  return (
    <Dialog open={true}>
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <DialogTitle>Welcome to UX-Beauty!</DialogTitle>
        <DialogContentText
          align="center"
          sx={theme => ({ fontSize: theme.typography.body1.fontSize })}
        >
          We're delighted to have you join us. <br />
          <br />
          <br />
          Before you immerse yourself in our world of beauty inspiration, kindly
          take a moment to review and accept our terms and cookie policy.
        </DialogContentText>
        <FormControlLabel
          sx={theme => ({
            my: 1,
            mx: 0,
            fontSize: theme.typography.subtitle1.fontSize
          })}
          required
          control={
            <Checkbox
              required
              checked={checked}
              onChange={() => setChecked(!checked)}
            />
          }
          componentsProps={{ typography: { variant: 'subtitle1' } }}
          label={
            <>
              I agree to the terms of the website’s{' '}
              <Link component={RouterLink} to="/legal-notice" target="_blank">
                Privacy & Cookies policy
              </Link>
            </>
          }
        />
        <DialogContentText align="center">
          We'll promptly reach out to confirm your access rights on the
          platform. <br />
          In the meantime, feel free to kickstart your journey on UX-Beauty by
          searching for an ingredient or a marketing concept!
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
        <Button
          onClick={() => {
            auth.signoutRedirect({
              post_logout_redirect_uri:
                window.location.origin + window.location.pathname
            });
          }}
        >
          Logout
        </Button>
        <LoadingButton
          variant="contained"
          disabled={!checked}
          onClick={() => signup()}
          loading={signupResult.loading}
        >
          Start exploring!
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
